webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoPlayer__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_VideoPlayer__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/vue-video',
    name: 'Video',
    component: __WEBPACK_IMPORTED_MODULE_3__components_VideoPlayer___default.a
  }]
}));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(11)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(25),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {}
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tween_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_somi_dashjs__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_somi_dashjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_somi_dashjs__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'somiVideoPlayer',
    data: function data() {
        return {
            streamText: "",
            player: {
                dom: null,

                videoUrl: "",
                currentTime: "",
                videoTotalTime: "",
                paused: true,
                fullScreen: false,
                playerKeyDown: false,
                svgState: {
                    show: "",
                    loading: ""
                },
                menu: {
                    styleObject: {}
                },
                controller: {
                    hide: true,
                    timeOutId: 0,
                    sliderBar: {
                        playedPosition: 0,
                        playedPercentage: 0,
                        bufferedStyles: [],
                        hoverPosition: 0,
                        focus: false,
                        previewVideo: null,
                        position: {}
                    },
                    mainButton: {
                        play: {
                            type: "path",
                            points: {
                                "1x": 12,
                                "1y": 26,
                                "2x": 18.5,
                                "2y": 22,
                                "3x": 18.5,
                                "3y": 14,
                                "4x": 12,
                                "4y": 10,
                                "5x": 18.5,
                                "5y": 22,
                                "6x": 25,
                                "6y": 18,
                                "7x": 25,
                                "7y": 18,
                                "8x": 18.5,
                                "8y": 14
                            },
                            fill: "#fff"
                        },
                        paused: {
                            type: "path",
                            points: {
                                "1x": 12,
                                "1y": 26,
                                "2x": 16,
                                "2y": 26,
                                "3x": 16,
                                "3y": 10,
                                "4x": 12,
                                "4y": 10,
                                "5x": 21,
                                "5y": 26,
                                "6x": 25,
                                "6y": 26,
                                "7x": 25,
                                "7y": 10,
                                "8x": 21,
                                "8y": 10
                            },
                            fill: "#fff"
                        },
                        transitionPoint: {
                            "1x": 12,
                            "1y": 26,
                            "2x": 18.5,
                            "2y": 22,
                            "3x": 18.5,
                            "3y": 14,
                            "4x": 12,
                            "4y": 10,
                            "5x": 18.5,
                            "5y": 22,
                            "6x": 25,
                            "6y": 18,
                            "7x": 25,
                            "7y": 18,
                            "8x": 18.5,
                            "8y": 14
                        }
                    },
                    videoTime: {
                        currentTime: 0,
                        duration: 0
                    },
                    fullScreenButton: {},
                    volume: {
                        slider: {
                            class: {
                                width: "100%"
                            },
                            focus: false,
                            position: {}
                        },
                        svg: {
                            points: {
                                'Max': {
                                    'M1x': 41,
                                    'M1y': 6,
                                    'M2x': 41,
                                    'M2y': 58,
                                    'M3x': 3,
                                    'M3y': 13,
                                    'M4x': 7,
                                    'M4y': 3,
                                    'stroke': 10
                                },
                                'Medium': {
                                    'M1x': 37,
                                    'M1y': 18,
                                    'M2x': 37,
                                    'M2y': 46,
                                    'M3x': 3,
                                    'M3y': 13,
                                    'M4x': 7,
                                    'M4y': 3,
                                    'stroke': 10
                                },
                                'Min': {
                                    'M1x': 37,
                                    'M1y': 18,
                                    'M2x': 37,
                                    'M2y': 46,
                                    'M3x': 55,
                                    'M3y': 51,
                                    'M4x': 48,
                                    'M4y': 55,
                                    'stroke': 5
                                }
                            },
                            transitionPoint: {
                                'M1x': 41,
                                'M1y': 6,
                                'M2x': 41,
                                'M2y': 58,
                                'M3x': 3,
                                'M3y': 13,
                                'M4x': 7,
                                'M4y': 3,
                                'stroke': 10
                            }
                        }
                    }
                }
            }
        };
    },

    computed: {
        playedStyle: function playedStyle() {
            return {
                width: this.player.controller.sliderBar.playedPosition + "px"
            };
        },
        getMainButtonSvgD: function getMainButtonSvgD() {
            var point = this.player.controller.mainButton.transitionPoint;
            return "M " + point['1x'] + " " + point['1y'] + " " + point['2x'] + " " + point['2y'] + " " + point['3x'] + " " + point['3y'] + " " + point['4x'] + " " + point['4y'] + " z" + "M " + point['5x'] + " " + point['5y'] + " " + point['6x'] + " " + point['6y'] + " " + point['7x'] + " " + point['7y'] + " " + point['8x'] + " " + point['8y'] + " z";
        },
        getVolumeSvgD: function getVolumeSvgD() {
            var point = this.player.controller.volume.svg.transitionPoint;
            return "M 0 22 L 12 22 L 32 5 L 32 59 L 12 42 L 0 42 M 36,22 A " + point.stroke + ",10 0 0 1 36,42 L 36,38 M" + point.M1x + "," + point.M1y + " A 11,13 0 0 1 " + point.M2x + "," + point.M2y + " L 37,46 A 11,13 0 0 0 37,18" + "M3,13 L7,3 L " + point.M3x + "," + point.M3y + " L " + point.M4x + "," + point.M4y;
        },
        stringCurrentTime: function stringCurrentTime() {
            return this.toHHMMSS(this.player.controller.videoTime.currentTime.toString());
        },
        stringDuration: function stringDuration() {
            return this.toHHMMSS(this.player.controller.videoTime.duration.toString());
        },
        getSliderHoverLeft: function getSliderHoverLeft() {
            if (this.player.controller.sliderBar.focus) {
                return {
                    left: this.player.controller.sliderBar.hoverPosition + "px",
                    visibility: "visible"
                };
            } else {
                return {
                    left: this.player.controller.sliderBar.hoverPosition + "px"
                };
            }
        },
        getSliderCurrentTime: function getSliderCurrentTime() {
            var percentage = 0;
            if (document.querySelector(".somi-slider-bar")) {
                percentage = this.player.controller.sliderBar.hoverPosition / document.querySelector(".somi-slider-bar").offsetWidth;
            }
            return this.toHHMMSS(percentage * this.player.controller.videoTime.duration);
        }
    },
    methods: {
        v_loadstart: function v_loadstart(e) {
            this.player.svgState.loading = "loading show";
        },
        v_loadedmetadata: function v_loadedmetadata(e) {
            var video = e.srcElement || e.target;
            this.player.controller.videoTime.duration = video.duration;
            video.play();
        },
        v_waiting: function v_waiting() {
            this.player.svgState.loading = "loading show";
        },
        v_canplay: function v_canplay(e) {
            this.player.svgState.loading = "";
        },
        v_play: function v_play(e) {
            var video = e.srcElement || e.target;
            var _this = this;
            this.player.paused = video.paused;
            var tween = new __WEBPACK_IMPORTED_MODULE_0_tween_js___default.a.Tween(_this.player.controller.mainButton.transitionPoint).to(_this.player.controller.mainButton.paused.points, 150).start();
            requestAnimationFrame(this.svgAnimate);
            clearTimeout(_this.player.controller.timeOutId);
            _this.player.controller.timeOutId = setTimeout(function () {
                if (!video.paused) {
                    _this.player.controller.hide = true;
                }
            }, 2000);
        },
        v_pause: function v_pause(e) {
            var video = e.srcElement || e.target;
            this.player.paused = video.paused;
            var _this = this;
            var tween = new __WEBPACK_IMPORTED_MODULE_0_tween_js___default.a.Tween(_this.player.controller.mainButton.transitionPoint).to(_this.player.controller.mainButton.play.points, 150).start();
            requestAnimationFrame(this.svgAnimate);
            _this.player.controller.hide = false;
        },
        v_timeupdate: function v_timeupdate(e) {
            var video = e.srcElement || e.target;
            this.player.controller.videoTime.currentTime = video.currentTime;
            this.player.controller.sliderBar.percentage = video.currentTime / video.duration;
            this.player.controller.sliderBar.playedPosition = this.player.controller.sliderBar.percentage * document.querySelector(".somi-slider-bar").offsetWidth;
        },
        v_progress: function v_progress(e) {
            var video = e.srcElement || e.target;
            var bufferedarr = [];
            for (var i = 0; i < video.buffered.length; i++) {
                bufferedarr.push({
                    left: 100 * video.buffered.start(i) / video.duration + "%",
                    right: 100 * (1 - video.buffered.end(i) / video.duration) + "%"
                });
            }
            this.player.controller.sliderBar.bufferedStyles = bufferedarr;
        },
        v_error: function v_error(e) {
            var video = e.srcElement || e.target;
        },
        v_volumechange: function v_volumechange(e) {
            var video = e.srcElement || e.target;
            var _tween = null;
            var _this = this;
            if (video.muted) {
                _tween = new __WEBPACK_IMPORTED_MODULE_0_tween_js___default.a.Tween(this.player.controller.volume.svg.transitionPoint).to(this.player.controller.volume.svg.points.Min, 100);
                this.player.controller.volume.slider.class = {
                    width: "0%"
                };
            } else {
                this.player.controller.volume.slider.class = {
                    width: 100 * video.volume + "%"
                };
                if (video.volume >= .5) {
                    _tween = new __WEBPACK_IMPORTED_MODULE_0_tween_js___default.a.Tween(_this.player.controller.volume.svg.transitionPoint).to(_this.player.controller.volume.svg.points.Max, 100);
                }
                if (.5 > video.volume >= .1) {
                    _tween = new __WEBPACK_IMPORTED_MODULE_0_tween_js___default.a.Tween(_this.player.controller.volume.svg.transitionPoint).to(_this.player.controller.volume.svg.points.Medium, 100);
                }
                if (video.volume <= .01) {
                    _tween = new __WEBPACK_IMPORTED_MODULE_0_tween_js___default.a.Tween(_this.player.controller.volume.svg.transitionPoint).to(_this.player.controller.volume.svg.points.Min, 100);
                }
            }
            _tween.start();
            requestAnimationFrame(this.svgAnimate);
        },
        v_setMuted: function v_setMuted() {
            document.querySelector(".somi-main-video").muted = !document.querySelector(".somi-main-video").muted;
        },
        playVideo: function playVideo() {
            var video = document.querySelector(".somi-main-video");
            if (video.paused) {
                video.play();
                this.player.svgState.show = "play show";
            } else {
                video.pause();
                this.player.svgState.show = "pause show";
            }
        },
        fullScreen: function fullScreen() {
            var el = document.querySelector(".somi-player-box");
            var fullscreenEnabled = document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
            var rfs = el.requestFullscreen || el.webkitRequestFullscreen || el.mozRequestFullScreen || el.msRequestFullscreen;
            var efs = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen;
            if (fullscreenEnabled) {
                if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
                    efs.call(document);
                } else {
                    rfs.call(el);
                }
            }
        },
        displayContextmenu: function displayContextmenu(e) {
            e.preventDefault();
        },
        displayMouseDown: function displayMouseDown(e) {
            var el = e.target || e.srcElement;
            if (el.nodeName == "A") {
                el.click();
            }
            if (e.button == 2) {
                this.player.menu.styleObject = {
                    top: e.offsetY + "px",
                    left: e.offsetX + "px",
                    visibility: "visible"
                };
            } else {
                this.player.menu.styleObject = {
                    top: e.offsetY + "px",
                    left: e.offsetX + "px",
                    visibility: "hidden"
                };
            }
        },
        sliderEnter: function sliderEnter(e) {
            this.player.controller.sliderBar.previewVideo = document.querySelector(".somi-preview-video");
        },
        sliderLeave: function sliderLeave(e) {
            if (this.player.controller.sliderBar.focus) {
                var video = document.querySelector(".somi-main-video");
                this.player.controller.sliderBar.focus = false;
                var position = e.clientX - document.querySelector(".somi-player-container").offsetLeft - document.querySelector(".somi-controller").offsetLeft;
                this.player.controller.sliderBar.hoverPosition = position;
                video.currentTime = this.player.controller.sliderBar.playedPercentage * video.duration;
                video.play();
            }
            if (this.player.controller.volume.slider.focus) {
                this.player.controller.volume.slider.focus = false;
            }
        },
        sliderMove: function sliderMove(e) {
            var _this = this;
            var video = document.querySelector(".somi-main-video");
            var sliderBar = document.querySelector(".somi-slider-bar");
            var sliderPosition = e.clientX - this.player.controller.sliderBar.position.x;
            _this.player.controller.hide = false;
            this.player.controller.sliderBar.hoverPosition = sliderPosition;
            if (this.player.controller.sliderBar.focus) {
                this.player.controller.sliderBar.playedPosition = sliderPosition;
                this.player.controller.sliderBar.playedPercentage = sliderPosition / sliderBar.offsetWidth;
                this.player.controller.videoTime.currentTime = this.player.controller.sliderBar.playedPercentage * video.duration;
                video.currentTime = this.player.controller.sliderBar.playedPercentage * video.duration;
            }
            if (this.player.controller.volume.slider.focus) {
                var VolumeSliderPosition = e.clientX - this.player.controller.volume.slider.position.x;
                if (0 <= VolumeSliderPosition && VolumeSliderPosition <= document.querySelector(".somi-total-volume").offsetWidth) {
                    video.volume = VolumeSliderPosition / document.querySelector(".somi-total-volume").offsetWidth;
                }
            }
            if (this.player.controller.sliderBar.previewVideo) {
                this.throttle(function () {
                    _this.player.controller.sliderBar.previewVideo.currentTime = sliderPosition / sliderBar.offsetWidth * video.duration;
                }, 100)();
            }
            clearTimeout(_this.player.controller.timeOutId);
            _this.player.controller.timeOutId = setTimeout(function () {
                if (!video.paused) {
                    _this.player.controller.hide = true;
                }
            }, 2000);
        },
        sliderDown: function sliderDown(e) {
            var video = document.querySelector(".somi-main-video");
            var sliderBar = document.querySelector(".somi-slider-bar");
            var position = e.clientX - this.player.controller.sliderBar.position.x;
            this.player.controller.sliderBar.hoverPosition = position;
            if (!video.paused) {
                video.pause();
            }
            this.player.controller.sliderBar.focus = true;
            this.player.controller.sliderBar.playedPercentage = position / sliderBar.offsetWidth;
            video.currentTime = this.player.controller.sliderBar.playedPercentage * video.duration;
        },
        sliderUp: function sliderUp(e) {
            if (this.player.controller.sliderBar.focus) {
                var video = document.querySelector(".somi-main-video");
                this.player.controller.sliderBar.focus = false;
                video.play();
            }
            if (this.player.controller.volume.slider.focus) {
                this.player.controller.volume.slider.focus = false;
            }
        },
        volumeSliderDown: function volumeSliderDown(e) {
            var video = document.querySelector(".somi-main-video");
            video.muted = false;
            this.player.controller.volume.slider.focus = true;
            var position = e.clientX - this.player.controller.volume.slider.position.x;
            video.volume = position / document.querySelector(".somi-total-volume").clientWidth;
        },
        transitionEnd: function transitionEnd() {
            this.player.svgState.show = "";
        },
        videoKeyDown: function videoKeyDown(e) {
            if (e.preventDefault) {
                e.preventDefault();
            }
            if (this.playerKeyDown) {
                return;
            } else {
                this.playerKeyDown = true;
            }
            var video = document.querySelector(".somi-main-video");
            switch (e.keyCode) {
                case 37:
                    if (video.currentTime >= 5) {
                        video.currentTime -= 5;
                    } else {
                        video.currentTime = 0;
                    }
                    this.player.svgState.show = "back show";
                    break;
                case 38:
                    if (video.volume <= .9) {
                        video.volume += .1;
                    } else {
                        video.volume = 1;
                    }
                    this.player.svgState.show = "up show";
                    break;
                case 39:
                    if (video.currentTime <= video.duration - 5) {
                        video.currentTime += 5;
                    } else {
                        video.currentTime = video.duration;
                    }
                    this.player.svgState.show = "ahead show";
                    break;
                case 40:
                    if (video.volume > .1) {
                        video.volume -= .1;
                    } else {
                        video.volume = 0;
                    }
                    this.player.svgState.show = "down show";
                    break;
                case 32:
                    if (video.paused) {
                        video.play();
                        this.player.svgState.show = "play show";
                    } else {
                        video.pause();
                        this.player.svgState.show = "pause show";
                    }
            }
            this.playerKeyDown = false;
        },
        fullScreenChange: function fullScreenChange(e) {
            if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
                this.player.fullScreen = true;
            } else {
                this.player.fullScreen = false;
            }
        },
        toHHMMSS: function toHHMMSS(_string) {
            var sec_num = parseInt(_string, 10);
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - hours * 3600) / 60);
            var seconds = sec_num - hours * 3600 - minutes * 60;

            if (hours) {
                if (hours < 10) {
                    hours = "0" + hours + ":";
                } else {
                    hours = hours + ":";
                }
            } else {
                hours = "";
            }
            if (minutes < 10) {
                minutes = "0" + minutes + ":";
            } else {
                minutes = minutes + ":";
            }
            if (seconds < 10) {
                seconds = "0" + seconds;
            }

            return hours + minutes + seconds;
        },
        getElementPosition: function getElementPosition(el) {
            var target = el;
            var position = {
                x: target.offsetLeft,
                y: target.offsetTop
            };
            target = target.offsetParent;
            while (target) {
                position.x += target.offsetLeft;
                position.y += target.offsetTop;
                target = target.offsetParent;
            }
            return position;
        },
        throttle: function throttle(fn, delay) {
            var timeID = null;
            return function () {
                var context = this,
                    args = arguments;
                clearTimeout(timeID);
                timeID = setTimeout(function () {
                    fn.apply(context, args);
                }, delay);
            };
        },
        svgAnimate: function svgAnimate() {
            requestAnimationFrame(this.svgAnimate);
            __WEBPACK_IMPORTED_MODULE_0_tween_js___default.a.update();
        }
    },
    mounted: function mounted() {
        this.player.controller.sliderBar.position = this.getElementPosition(document.querySelector(".somi-controller"));
        this.player.controller.volume.slider.position = this.getElementPosition(document.querySelector(".somi-total-volume"));
        console.log(__WEBPACK_IMPORTED_MODULE_2_somi_dashjs___default.a.isSupportDash(), 'your browser ' + (__WEBPACK_IMPORTED_MODULE_2_somi_dashjs___default.a.isSupportDash() ? 'is' : 'is not') + ' support MSE');
        var segmentUrl = '/vue-video/static/VivaLaVida_dashinit.mp4';
        var videoMimeTypeCodecs = 'video/mp4;codecs="avc1.4d401f,mp4a.40.2"';
        var initRange = { start: 0, end: 1420 };
        var sidxRange = { start: 1421, end: 2064 };
        var player = new __WEBPACK_IMPORTED_MODULE_2_somi_dashjs___default.a('#mainVideo', segmentUrl, videoMimeTypeCodecs, initRange, sidxRange);
        console.log('somi-dashjs', player);
    }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(4);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(13)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(27),
  /* scopeId */
  "data-v-6b911a80",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(12)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(26),
  /* scopeId */
  "data-v-5dba0faa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22)
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "somi-player-container"
  }, [_c('div', {
    staticClass: "somi-player-box",
    on: {
      "fullscreenchange": _vm.fullScreenChange,
      "webkitfullscreenchange": _vm.fullScreenChange,
      "mozfullscreenchange": _vm.fullScreenChange,
      "MSFullscreenChange": _vm.fullScreenChange
    }
  }, [_c('div', {
    staticClass: "somi-player-display",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "mousedown": _vm.displayMouseDown,
      "mousemove": _vm.sliderMove,
      "mouseleave": _vm.sliderLeave,
      "mouseup": _vm.sliderUp,
      "keydown": _vm.videoKeyDown,
      "contextmenu": _vm.displayContextmenu
    }
  }, [_c('div', {
    staticClass: "somi-menu",
    style: (_vm.player.menu.styleObject)
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "somi-event-div",
    on: {
      "dblclick": _vm.fullScreen,
      "click": _vm.playVideo
    }
  }, [_c('svg', {
    class: _vm.player.svgState.show,
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "-18 -19 70 70"
    },
    on: {
      "transitionend": _vm.transitionEnd,
      "transition": _vm.transitionEnd,
      "OTransition": _vm.transitionEnd,
      "MozTransition": _vm.transitionEnd
    }
  }, [_c('g', {
    staticClass: "time-back",
    attrs: {
      "transform": "scale(0.03125 0.03125)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M512 64c-141.384 0-269.376 57.32-362.032 149.978l-149.968-149.978v384h384l-143.532-143.522c69.496-69.492 165.492-112.478 271.532-112.478 212.068 0 384 171.924 384 384 0 114.696-50.292 217.636-130.018 288l84.666 96c106.302-93.816 173.352-231.076 173.352-384 0-282.77-229.23-512-512-512z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "time-ahead",
    attrs: {
      "transform": "scale(0.03125 0.03125)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 576c0 152.924 67.048 290.184 173.35 384l84.666-96c-79.726-70.364-130.016-173.304-130.016-288 0-212.076 171.93-384 384-384 106.042 0 202.038 42.986 271.53 112.478l-143.53 143.522h384v-384l-149.97 149.978c-92.654-92.658-220.644-149.978-362.030-149.978-282.77 0-512 229.23-512 512z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "video-pause",
    attrs: {
      "transform": "scale(0.03125 0.03125)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M192 128l640 384-640 384z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "video-play",
    attrs: {
      "transform": "scale(0.03125 0.03125)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M128 128h320v768h-320zM576 128h320v768h-320z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "volume-up",
    attrs: {
      "transform": "scale(0.03125 0.03125)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1024 576h-192v192h-128v-192h-192v-128h192v-192h128v192h192v128z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "volume-down",
    attrs: {
      "transform": "scale(0.03125 0.03125)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M512 448h512v128h-512v-128z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M416.006 960c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
    }
  })])]), _vm._v(" "), _c('svg', {
    class: _vm.player.svgState.loading,
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "-18 -19 70 70"
    }
  }, [_c('g', {
    attrs: {
      "transform": "scale(0.03125 0.03125)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M384 128c0-70.692 57.308-128 128-128s128 57.308 128 128c0 70.692-57.308 128-128 128s-128-57.308-128-128zM790.994 512c0 0 0 0 0 0 0-57.993 47.013-105.006 105.006-105.006s105.006 47.013 105.006 105.006c0 0 0 0 0 0 0 57.993-47.013 105.006-105.006 105.006s-105.006-47.013-105.006-105.006zM688.424 783.53c0-52.526 42.58-95.106 95.106-95.106s95.106 42.58 95.106 95.106c0 52.526-42.58 95.106-95.106 95.106s-95.106-42.58-95.106-95.106zM425.862 896c0-47.573 38.565-86.138 86.138-86.138s86.138 38.565 86.138 86.138c0 47.573-38.565 86.138-86.138 86.138s-86.138-38.565-86.138-86.138zM162.454 783.53c0-43.088 34.93-78.018 78.018-78.018s78.018 34.93 78.018 78.018c0 43.088-34.93 78.018-78.018 78.018s-78.018-34.93-78.018-78.018zM57.338 512c0-39.026 31.636-70.662 70.662-70.662s70.662 31.636 70.662 70.662c0 39.026-31.636 70.662-70.662 70.662s-70.662-31.636-70.662-70.662zM176.472 240.472c0 0 0 0 0 0 0-35.346 28.654-64 64-64s64 28.654 64 64c0 0 0 0 0 0 0 35.346-28.654 64-64 64s-64-28.654-64-64zM899.464 240.472c0 64.024-51.906 115.934-115.936 115.934-64.024 0-115.936-51.91-115.936-115.934 0-64.032 51.912-115.934 115.936-115.934 64.030 0 115.936 51.902 115.936 115.934z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "somi-controller-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "somi-controller",
    class: {
      'somi-hide': _vm.player.controller.hide
    }
  }, [_c('div', {
    staticClass: "somi-slider-bar",
    on: {
      "mousedown": _vm.sliderDown,
      "mouseenter": _vm.sliderEnter
    }
  }, [_c('div', {
    staticClass: "somi-slider-played",
    style: (_vm.playedStyle)
  }), _vm._v(" "), _vm._l((_vm.player.controller.sliderBar.bufferedStyles), function(bufferedStyle) {
    return _c('div', {
      staticClass: "somi-slider-buffered",
      style: (bufferedStyle)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "somi-slider-preview-box",
    style: (_vm.getSliderHoverLeft)
  }), _vm._v(" "), _c('span', {
    staticClass: "somi-slider-currentTime",
    style: (_vm.getSliderHoverLeft)
  }, [_vm._v("\n                    " + _vm._s(_vm.getSliderCurrentTime) + "\n                ")])], 2), _vm._v(" "), _c('button', {
    staticClass: "somi-main-button",
    on: {
      "click": _vm.playVideo
    }
  }, [_c('svg', {
    staticClass: "main-button-svg",
    class: {
      'button-play': _vm.player.paused, 'button-paused': !_vm.player.paused
    },
    attrs: {
      "height": "100%",
      "version": "1.1",
      "viewBox": "0 0 36 36",
      "width": "100%"
    }
  }, [_c('path', {
    staticClass: "play-svg-fill",
    attrs: {
      "d": _vm.getMainButtonSvgD,
      "id": "ytp-svg-477"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "somi-volume-container"
  }, [_c('button', {
    staticClass: "somi-volume",
    on: {
      "click": _vm.v_setMuted
    }
  }, [_c('svg', {
    staticClass: "icon-volume",
    attrs: {
      "viewBox": "-20 -24 100 110",
      "fill": "currentColor",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": _vm.getVolumeSvgD
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "somi-volume-slider-container",
    on: {
      "!mousedown": function($event) {
        return _vm.volumeSliderDown($event)
      }
    }
  }, [_c('div', {
    staticClass: "somi-total-volume"
  }, [_c('div', {
    style: (_vm.player.controller.volume.slider.class),
    attrs: {
      "claSS": "somi-current-volume"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "videoTime"
  }, [_c('span', {
    staticClass: "videoCurrentTime"
  }, [_vm._v(_vm._s(_vm.stringCurrentTime))]), _vm._v(" "), _c('span', {}, [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "videoTotalTime"
  }, [_vm._v(_vm._s(_vm.stringDuration))])]), _vm._v(" "), _c('button', {
    staticClass: "somi-fullScreen-button",
    on: {
      "click": _vm.fullScreen
    }
  }, [_c('svg', {
    staticClass: "svg-fullScreen",
    class: {
      fullScreen: _vm.player.fullScreen
    },
    attrs: {
      "height": "100%",
      "version": "1.1",
      "viewBox": "0 0 36 36",
      "width": "100%"
    }
  }, [_c('g', {
    staticClass: "ytp-fullscreen-button-corner-0"
  }, [_c('path', {
    staticClass: "ytp-svg-fill",
    attrs: {
      "d": "m 10,16 2,0 0,-4 4,0 0,-2 L 10,10 l 0,6 0,0 z",
      "id": "ytp-svg-19"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "ytp-fullscreen-button-corner-1"
  }, [_c('path', {
    staticClass: "ytp-svg-fill",
    attrs: {
      "d": "m 20,10 0,2 4,0 0,4 2,0 L 26,10 l -6,0 0,0 z",
      "id": "ytp-svg-20"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "ytp-fullscreen-button-corner-2"
  }, [_c('path', {
    staticClass: "ytp-svg-fill",
    attrs: {
      "d": "m 24,24 -4,0 0,2 L 26,26 l 0,-6 -2,0 0,4 0,0 z",
      "id": "ytp-svg-21"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "ytp-fullscreen-button-corner-3"
  }, [_c('path', {
    staticClass: "ytp-svg-fill",
    attrs: {
      "d": "M 12,20 10,20 10,26 l 6,0 0,-2 -4,0 0,-4 0,0 z",
      "id": "ytp-svg-22"
    }
  })])])])])]), _vm._v(" "), _c('video', {
    staticClass: "somi-main-video",
    attrs: {
      "id": "mainVideo",
      "src": _vm.player.videoUrl
    },
    on: {
      "loadstart": _vm.v_loadstart,
      "loadedmetadata": _vm.v_loadedmetadata,
      "waiting": _vm.v_waiting,
      "canplay": _vm.v_canplay,
      "play": _vm.v_play,
      "pause": _vm.v_pause,
      "timeupdate": _vm.v_timeupdate,
      "progress": _vm.v_progress,
      "volumechange": _vm.v_volumechange,
      "error": _vm.v_error
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vuejs.org/"
    }
  }, [_vm._v("Vue")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/SomiFrame/VueVideo"
    }
  }, [_vm._v("GitHub_Somi")])])
}]}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forum.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gitter.im/vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack/",
      "target": "_blank"
    }
  }, [_vm._v("Docs for This Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/awesome-vue",
      "target": "_blank"
    }
  }, [_vm._v("awesome-vue")])])])
}]}

/***/ })
],[9]);


// WEBPACK FOOTER //
// static/js/app.3807cb86ca99433396b7.js